export var PlatformEventType;
(function (PlatformEventType) {
    PlatformEventType["FilePublished"] = "file.published";
    PlatformEventType["FileUnpublished"] = "file.unpublished";
    PlatformEventType["TranscriptPublished"] = "transcript.published";
    PlatformEventType["TranscriptUnpublished"] = "transcript.unpublished";
})(PlatformEventType || (PlatformEventType = {}));
export var GenAIBrokerTopic;
(function (GenAIBrokerTopic) {
    GenAIBrokerTopic["PlatformEvents"] = "platform-events";
})(GenAIBrokerTopic || (GenAIBrokerTopic = {}));
